const state = {
  refreshOutboundList: false
}

const mutations = {
  SET_REFRESH_OUTBOUND_LIST_STATUS: (state, data) => {
    state.refreshOutboundList = data
  }
}

const actions = {
  refreshOutboundList({ commit }, data) {
    commit('SET_REFRESH_OUTBOUND_LIST_STATUS', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
